import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { defaultConfig } from './consts'

const Q = {
  get: async (url, config) => {
    return HTTP.get(url, Object.assign({}, defaultConfig, config))
  },
  put: async (url, data, config) => {
    return HTTP.put(url, data, Object.assign({}, defaultConfig, config))
  },
  post: async (url, data, config) => {
    return HTTP.post(url, data, Object.assign({}, defaultConfig, config))
  },
}

export const globalRegionLogin = async ({ region }, { headers = {} } = {}) => {
  try {
    const response = await Q.post(`/auth/region/login`, { region }, { headers })
    return { data: response.data, headers: response.headers }
  } catch (err) {
    notification.handleResponseError(err)
  }
}

export const globalPwdLogin = async ({ username, password }) => {
  try {
    const response = await Q.post(`/auth/pwd/login`, { username, password })
    return { data: response.data, headers: response.headers }
  } catch (err) {
    notification.handleResponseError(err, 'login')
  }
}

export const globalAuthLogin = async () => {
  try {
    const response = await Q.get(`/auth/login`)
    return response.data
  } catch (err) {
    throw err
  }
}

export const getUserByAdId = async (id) => {
  try {
    const response = await Q.get(`/users/AD/${id}`)
    return response.data
  } catch (err) {
    notification.handleResponseError(err, 'login')
    throw err
  }
}

export async function getGlobalAccountOptions () {
  try {
    const languagesRes = await Q.get(`/languages`)
    return {
      languages: languagesRes.data.data,
    }
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function getAllRegions () {
  try {
    const res = await Q.get(`/regions`, { headers: { needToken: false } })
    return res.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function updateEngineerDefaultLanguage (languageId) {
  try {
    const response = await Q.put(`/users/language/${languageId}`)
    return response.data
  } catch (err) {
    throw err
  }
}

export async function updateEngineerDefaultRegion (regionId) {
  try {
    const response = await Q.put(`/users/region/${regionId}`)
    return response.data
  } catch (err) {
    throw err
  }
}
